import { render, staticRenderFns } from "./TheResults.vue?vue&type=template&id=506d5806&scoped=true&"
import script from "./TheResults.vue?vue&type=script&lang=js&"
export * from "./TheResults.vue?vue&type=script&lang=js&"
import style0 from "./TheResults.vue?vue&type=style&index=0&id=506d5806&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d5806",
  null
  
)

export default component.exports